import React, { useState, useEffect } from 'react';
import { FaHeart, FaEye } from 'react-icons/fa';
import axios from 'axios';
import Swal from 'sweetalert2';
import TenderLogo from '../../../Assets/images/tenderLogo.png';
import TenderLogo1 from '../../../Assets/icon/BidMasterIcon.png';
import { useLocation, useNavigate } from 'react-router-dom';
import apiClient from './../../../Api/apiClient';
import TenderDescriptionDate from './../TenderDetails/TenderDescriptionDate';
import TenderDescriptionID from './../TenderDetails/TenderDescriptionID';
import BrowsInDashboard from './../TenderDetails/BrowsInDashboard';
import { PHOTO_BASE_URL_Admin } from '../../../Api/config';
import tenderNotFoundImage from '../../../Assets/images/tenderNotFoundImage.png';
import { Pagination } from 'antd';
const MyFavorite = ({
  searchQuery,
  selectedCategory,
  selectedDepartment,
  selectedDistrict,
  selectedUpazila,
  selectedSource,
}) => {
  const navigate = useNavigate();
  const [tenders, setTenders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(false);

  const [refresh, setRefresh] = useState(false)
  const tendersPerPage = 3;
  const fetchTenders = async () => {
    try {
      const response = await apiClient.get(
        '/user/tender-end-user/favourite',
        {
          params: {
            key: searchQuery,
            sub_sector_name: selectedCategory,
            sub_department_name: selectedDepartment,
            upazila_name: selectedUpazila,
            district_name: selectedDistrict,
            source_name: selectedSource,
          },
        }

      );
      console.log(response.data.data); // Debug API response structure
      setTenders(response.data?.data || []); // Access 'data' key directly and handle if it's missing

    } catch (error) {
      console.error('Error fetching tenders:', error.response || error);
    }
  };

  useEffect(() => {
    fetchTenders();

  }, [refresh]);

  useEffect(() => {
    fetchTenders();
  }, [
    searchQuery,
    selectedCategory,
    selectedDepartment,
    selectedDistrict,
    selectedUpazila,
    selectedSource,
  ]);


  // Calculate total pages for pagination
  const totalPages = Math.ceil(tenders.length / tendersPerPage);

  // Paginate filtered tenders
  const indexOfLastTender = currentPage * tendersPerPage;
  const indexOfFirstTender = indexOfLastTender - tendersPerPage;
  const currentTenders = tenders.slice(indexOfFirstTender, indexOfLastTender);

  function itemRender(current, type, originalElement) {
    if (type === 'prev') {
      return <a>Previous</a>;
    }
    if (type === 'next') {
      return <a>Next</a>;
    }
    return originalElement;
  }

  const handlePageChange = page => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      window.scrollTo(0, 0);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo(0, 0);
    }
  };

  // Toggle wishlist functions
  const addToFavorites = async tenderId => {
    const tenderID = tenderId.id;
    setLoading(true);
    try {
      const response = await apiClient.post('/user/tender-user/favourite', {
        ten_id: tenderID,
      });
      setWishlist(prev => [...prev, tenderID]);

      const successMessage = response?.data?.message || 'An unknown error occurred';
      Swal.fire({
        title: 'Success!',
        text: successMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
    } catch (error) {
      console.error('Error adding to favorites:', error);
      const errorMessage =
        error.response?.data?.message || 'An unknown error occurred';
      Swal.fire({
        title: 'Failed!',
        text: errorMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const removeFromFavorites = async tenderId => {
    const tenderID = tenderId.id;
    setLoading(true);
    try {
      const response = await apiClient.delete(
        `/user/tender-end-user/favourite/${tenderID}`
      );
      setWishlist(prev => prev.filter(id => id !== tenderID));
      const successMessage =
        response?.data?.message || 'An unknown error occurred';
      Swal.fire({
        title: 'Success!',
        text: successMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
      setRefresh(prev => !prev);
    } catch (error) {
      console.error('Error removing from favorites:', error);
      const errorMessage =
        error.response?.data?.message || 'An unknown error occurred';

      Swal.fire({
        title: 'Failed!',
        text: errorMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const toggleWishlist = tender => {
    if (loading) return; // Prevent duplicate requests
    if (wishlist.includes(tender.id)) {
      removeFromFavorites(tender);
    }

  };

  const handleViewDetailsClick = tenderId => {
    navigate(`/viewTenderDetails/${tenderId}`);
  };



  const [totalAdvertisements, setTotalAdvertisements] = useState([]);

  const adsPerPage = 3;
  const startAdIndex = (currentPage - 1) * adsPerPage;
  const endAdIndex = startAdIndex + adsPerPage;
  const adsToShow = totalAdvertisements.slice(startAdIndex, endAdIndex);


  const fetchAdvertisements = async () => {
    try {
      const response = await apiClient.get('/user/add', {
        params: { panel_name: 'favourite_list' },
      });
      setTotalAdvertisements(response.data.data);
    } catch (error) {
      console.error("Error fetching advertisements:", error);
    }
  };

  useEffect(() => {
    fetchAdvertisements();
  }, []);


  const handleAdClicked = (link) => {
    const fullLink = /^https?:\/\//.test(link) ? link : `http://${link}`;
    window.open(fullLink, "_blank");
    
};




  return (
    <div>
      <div className="md:p-10 p-4 bg-gray-100">
        <div className="flex flex-col md:flex-row gap-4">
          {/* Main Content */}
          <div className="w-full md:w-3/4">
            <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 md:text-sm text-xs">
              {currentTenders.length > 0 ? (
                currentTenders.map((tender, index) => (
                  <React.Fragment key={tender.id}>
                    {/* Tender Card */}
                    <div className="bg-white border  w-full shadow-md rounded-lg p-4 relative">
                      <h3 className="md:text-lg text-sm font-semibold mb-2 w-11/12">
                        <span className='text-blue-900'>Tender Title:</span>{tender.name}
                      </h3>
                      <div className="flex gap-4 bg-BrowsBg p-2 rounded-md">
                        <div className="mt-2 lg:ml-4 ml-2 mb-2">
                          <img
                            src={
                              tender.company_logo
                                ? `${PHOTO_BASE_URL_Admin}${tender.company_logo}`
                                : 'TenderLogo'
                            }
                            alt={`${tender.name} Logo`}
                            className="lg:w-36 w-14 h-12 lg:h-28 md:mx-auto lg:mx-auto"
                          />
                        </div>
                        <div>
                          <TenderDescriptionDate
                            data={{
                              submission_date: tender.submission_date,
                              expired_after: tender.expired_after,
                              publishOn: tender.publish_on,
                              publish_on_before: tender.publish_on_before,
                              tender_status: tender.tender_status,
                            }}
                          />
                        </div>
                      </div>
                      <div className="py-1.5 md:mt-2 mt-2">
                        <div>
                          <TenderDescriptionID
                            data={{
                              tenderID: tender.tender_id,
                              invitation_for: tender.invitation_for,
                              type: tender.type,
                            }}
                          />
                        </div>
                      </div>
                      <div className="flex md:mt-4 mt-2">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewDetailsClick(tender.ten_id);
                          }}
                          className="border border-gray-300 text-blue-400 py-1 px-4 rounded-md hover:bg-gray-100"
                        >
                          View Details
                        </button>
                      </div>
                      <FaHeart
                        className="absolute bottom-4 right-4 cursor-pointer text-red-500"
                        onClick={() => removeFromFavorites(tender)}
                      />
                      <div className="absolute top-4 right-4 flex items-center text-gray-500 bg-red-100 px-4 py-1 rounded-md">
                        <FaEye className="mr-1" />
                        <span>{0}</span>
                      </div>
                    </div>

                    {/* Show Ad Every 2 Tenders in Mobile View */}
                    {index % 2 === 1 && totalAdvertisements.length > 0 && (() => {
                      const sortedAds = [...totalAdvertisements].sort((a, b) => a.serial - b.serial);
                      const adIndex = Math.floor(index / 2) % sortedAds.length;
                      const ad = sortedAds[adIndex];

                      return ad ? (
                        <div onClick={() => handleAdClicked(ad.url_link)} className="w-full md:hidden cursor-pointer bg-gray-200 rounded-lg shadow-md p-2 text-center">
                          <img
                            src={`${PHOTO_BASE_URL_Admin}${ad.add_file}`}
                            alt={ad.name}
                            className="w-full h-60 rounded-md cover"
                          />
                        </div>
                      ) : null;
                    })()}
                  </React.Fragment>
                ))
              ) : (
                <div className="col-span-full text-center flex items-center justify-center md:w-3/4 w-full py-4 md:py-10">
                  <img src={tenderNotFoundImage} alt="" className="w-80 h-80" />
                </div>
              )}
            </div>

            <div className="my-3 flex justify-center">
              <Pagination
                current={currentPage}
                total={tenders.length}
                pageSize={tendersPerPage}
                onChange={handlePageChange}
                itemRender={itemRender}
              />
            </div>
          </div>

          {/* Sidebar Ads for Desktop View */}
          <div className="hidden md:flex flex-wrap justify-between gap-4 w-full md:w-1/4">
            <div className="w-full">
              <div className="sticky top-36 bottom-4 bg-gray-200 rounded-lg shadow-md ">
                {adsToShow.length > 0 ? (
                  adsToShow
                    .sort((a, b) => a.serial - b.serial)
                    .map((ad, index) => (
                      <div onClick={() => handleAdClicked(ad.url_link)} className="border cursor-pointer rounded-md mb-2 border-black" key={index}>
                        <img
                          src={`${PHOTO_BASE_URL_Admin}${ad.add_file}`}
                          alt={ad.name}
                          className="w-full h-60 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-md cover"
                        />
                      </div>
                    ))
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default MyFavorite;



// import { useState, useEffect } from 'react';
// import { FaHeart, FaEye } from 'react-icons/fa';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import TenderLogo from '../../../Assets/images/tenderLogo.png';
// import TenderLogo1 from '../../../Assets/icon/BidMasterIcon.png';
// import { useLocation, useNavigate } from 'react-router-dom';
// import apiClient from './../../../Api/apiClient';
// import TenderDescriptionDate from './../TenderDetails/TenderDescriptionDate';
// import TenderDescriptionID from './../TenderDetails/TenderDescriptionID';
// import BrowsInDashboard from './../TenderDetails/BrowsInDashboard';
// import { PHOTO_BASE_URL_Admin } from '../../../Api/config';
// import tenderNotFoundImage from '../../../Assets/images/tenderNotFoundImage.png';
// import { Pagination } from 'antd';
// const MyFavorite = ({
//   searchQuery,
//   selectedCategory,
//   selectedDepartment,
//   selectedDistrict,
//   selectedUpazila,
//   selectedSource,
// }) => {
//   const navigate = useNavigate();
//   const [tenders, setTenders] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [wishlist, setWishlist] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const[refresh, setRefresh]= useState(false)
//   const tendersPerPage = 3;
//   const fetchTenders = async () => {
//     try {
//       const response = await apiClient.get(
//         '/user/tender-end-user/favourite',
//         {
//           params: {
//             key: searchQuery,
//             sub_sector_name: selectedCategory,
//             sub_department_name: selectedDepartment,
//             upazila_name: selectedUpazila,
//             district_name: selectedDistrict,
//             source_name: selectedSource,
//           },
//         }
//         // searchQuery ||
//         //   selectedCategory ||
//         //   selectedDepartment ||
//         //   selectedDistrict ||
//         //   selectedUpazila ||
//         //   selectedSource
//         //   ? `/user/tender-end-user/favourite?key=${searchQuery}&sub_sector_name=${selectedCategory}&sub_department_name=${selectedDepartment}&upazila_name=${selectedUpazila}&source_name=${selectedSource}`
//         //   : '/user/tender-end-user/favourite'
//       );
//       console.log(response.data.data); // Debug API response structure
//       setTenders(response.data?.data || []); // Access 'data' key directly and handle if it's missing

//     } catch (error) {
//       console.error('Error fetching tenders:', error.response || error);
//     }
//   };

//   useEffect(() => {
//     fetchTenders();
//       // Reload after 1 seconds
//     // const interval = setInterval(() => {
//     //   fetchTenders();
//     // }, 1000);

//     // return () => clearInterval(interval);
//   }, [refresh]);

//   useEffect(() => {
//     fetchTenders();
//   }, [
//     searchQuery,
//     selectedCategory,
//     selectedDepartment,
//     selectedDistrict,
//     selectedUpazila,
//     selectedSource,
//   ]);

//   // Filter tenders based on the search query
//   // const filteredTenders = tenders.filter(tender => {
//   //   const query =
//   //     searchQuery ||
//   //     selectedCategory ||
//   //     selectedDepartment ||
//   //     selectedDistrict ||
//   //     selectedUpazila ||
//   //     selectedSource ||
//   //     '';
//   //   return (
//   //     tender.name?.includes(query) ||
//   //     tender.tender_id?.includes(query) ||
//   //     tender.department_name?.includes(query) ||
//   //     tender.sub_sector_name?.includes(query) ||
//   //     tender.district_name?.includes(query) ||
//   //     tender.upazila_name?.includes(query) ||
//   //     tender.source_name?.includes(query)
//   //   );
//   // });

//   // Calculate total pages for pagination
//   const totalPages = Math.ceil(tenders.length / tendersPerPage);

//   // Paginate filtered tenders
//   const indexOfLastTender = currentPage * tendersPerPage;
//   const indexOfFirstTender = indexOfLastTender - tendersPerPage;
//   const currentTenders = tenders.slice(indexOfFirstTender, indexOfLastTender);

//     function itemRender(current, type, originalElement) {
//       if (type === 'prev') {
//         return <a>Previous</a>;
//       }
//       if (type === 'next') {
//         return <a>Next</a>;
//       }
//       return originalElement;
//     }

//     const handlePageChange = page => {
//       setCurrentPage(page);
//       window.scrollTo(0, 0);
//     };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//       window.scrollTo(0, 0);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//       window.scrollTo(0, 0);
//     }
//   };

//   // Toggle wishlist functions
//   const addToFavorites = async tenderId => {
//     const tenderID = tenderId.id;
//     setLoading(true);
//     try {
//       const response = await apiClient.post('/user/tender-user/favourite', {
//         ten_id: tenderID,
//       });
//       setWishlist(prev => [...prev, tenderID]);

//       const successMessage =  response?.data?.message || 'An unknown error occurred';
//       Swal.fire({
//         title: 'Success!',
//         text: successMessage,
//         customClass: {
//           popup: 'w-72 h-auto p-3',
//           title: 'text-lg',
//           content: 'text-xs',
//           confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
//         },
//       });
//     } catch (error) {
//       console.error('Error adding to favorites:', error);
//       const errorMessage =
//         error.response?.data?.message || 'An unknown error occurred';
//       Swal.fire({
//         title: 'Failed!',
//         text: errorMessage,
//         customClass: {
//           popup: 'w-72 h-auto p-3',
//           title: 'text-lg',
//           content: 'text-xs',
//           confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
//         },
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const removeFromFavorites = async tenderId => {
//     const tenderID = tenderId.id;
//     setLoading(true);
//     try {
//       const response = await apiClient.delete(
//         `/user/tender-end-user/favourite/${tenderID}`
//       );
//       setWishlist(prev => prev.filter(id => id !== tenderID));
//       const successMessage =
//         response?.data?.message || 'An unknown error occurred';
//       Swal.fire({
//         title: 'Success!',
//         text: successMessage,
//         customClass: {
//           popup: 'w-72 h-auto p-3',
//           title: 'text-lg',
//           content: 'text-xs',
//           confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
//         },
//       });
//       setRefresh(prev => !prev);
//     } catch (error) {
//       console.error('Error removing from favorites:', error);
//       const errorMessage =
//         error.response?.data?.message || 'An unknown error occurred';

//       Swal.fire({
//         title: 'Failed!',
//         text: errorMessage,
//         customClass: {
//           popup: 'w-72 h-auto p-3',
//           title: 'text-lg',
//           content: 'text-xs',
//           confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
//         },
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const toggleWishlist = tender => {
//     if (loading) return; // Prevent duplicate requests
//     if (wishlist.includes(tender.id)) {
//       removeFromFavorites(tender);
//     }
//     // else {
//     //   addToFavorites(tender);
//     // }
//   };

//   const handleViewDetailsClick = tenderId => {
//     navigate(`/viewTenderDetails/${tenderId}`);
//   };

//   return (
//     <div>
//       {/* <h1 className="md:px-8 md:mb-6 mb-4 md:text-xl text-lg font-semibold text-gray-600">
//         Total {TotalTender} Tenders
//       </h1> */}
//       <div className="md:p-10 p-4 bg-gray-100">
//         <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 md:text-sm text-xs">
//           {/* <h1>Your filter matched with {currentTenders.length} results</h1> */}
//           {currentTenders.length > 0 ? (
//             currentTenders.map((tender, index) => (
//               <div
//                 key={tender.id}
//                 className="bg-white border md:w-2/3 2xl:w-1/2 w-full shadow-md rounded-lg p-4 relative"
//               >
//                 <h3 className="md:text-lg text-sm font-semibold mb-2 w-11/12">
//                   {tender.name}
//                 </h3>

//                 <div className="flex gap-4 bg-BrowsBg p-2 rounded-md">
//                   <div className="mt-2 lg:ml-4 ml-2 mb-2">
//                     <img
//                       src={
//                         tender.company_logo // Check if logo exists in the tender object
//                           ? `${PHOTO_BASE_URL_Admin}${tender.company_logo}`
//                           : 'TenderLogo' // Placeholder image if no logo is available
//                       }
//                       alt={`${tender.name} Logo`}
//                       className="lg:w-36 w-14 h-12 lg:h-28 md:mx-auto lg:mx-auto"
//                     />
//                   </div>
//                   <div>
//                     <TenderDescriptionDate
//                       data={{
//                         submission_date: tender.submission_date,
//                         expired_after: tender.expired_after,
//                         publishOn: tender.publish_on,
//                         publish_on_before: tender.publish_on_before,
//                         tender_status: tender.tender_status,
//                       }}
//                     />
//                   </div>
//                 </div>
//                 <div className="py-1.5 md:mt-2 mt-2">
//                   <div>
//                     <TenderDescriptionID
//                       data={{
//                         tenderID: tender.tender_id,
//                         invitation_for: tender.invitation_for,
//                         type: tender.type,
//                       }}
//                     />
//                   </div>
//                 </div>
//                 <div className="flex md:mt-4 mt-2">
//                   <button
//                     onClick={e => {
//                       e.stopPropagation();
//                       handleViewDetailsClick(tender.ten_id);
//                     }}
//                     className=" border border-gray-300 text-blue-400 py-1 px-4 rounded-md hover:bg-gray-100"
//                   >
//                     View Details
//                   </button>
//                 </div>
//                 <FaHeart
//                   className="absolute bottom-4 right-4 cursor-pointer text-red-500"
//                   onClick={() => removeFromFavorites(tender)}
//                 />

//                 <div className="absolute top-4 right-4 flex items-center text-gray-500 bg-red-100 px-4 py-1 rounded-md">
//                   <FaEye className="mr-1" />
//                   {/* <span>{tenderViewers[tender.id] || 0}</span> */}
//                   <span>{0}</span>
//                 </div>
//               </div>
//             ))
//           ) : (
//             // <p className="text-center text-red-500">No Tender found.</p>
//             <div className="col-span-full text-cente flex items-center justify-center md:w-3/4 w-full py-4 md:py-10">
//               <img src={tenderNotFoundImage} alt="" className="w-80 h-80" />
//             </div>
//           )}
//         </div>

//         <div className="my-3 flex justify-center">
//           <Pagination
//             current={currentPage}
//             total={tenders.length}
//             pageSize={tendersPerPage}
//             onChange={handlePageChange}
//             itemRender={itemRender}
//           />
//         </div>

//         {/* <div className="flex justify-center gap-6 md:w-3/4 w-full items-center md:mt-8 mt-6">
//           <button
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//             className="md:px-4 px-2 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded disabled:opacity-50"
//           >
//             &lt; Previous
//           </button>
//           <span>
//             Page {currentPage} of {totalPages}
//           </span>
//           <button
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//             className="md:px-4 px-2 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded disabled:opacity-50"
//           >
//             Next &gt;
//           </button>
//         </div> */}
//       </div>
//     </div>
//     // <div className="p-4">
//     //   <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 md:text-sm text-xs">
//     //     {currentTenders.length > 0 ? (
//     //       currentTenders.map((tender, index) => (
//     //         <div
//     //           key={tender.id}
//     //           className="bg-BrowsBg md:w-3/4 w-full shadow-md rounded-lg p-4 relative"
//     //         >
//     //           <h3 className="md:text-lg text-sm font-semibold mb-2 w-11/12">
//     //             {tender.name}
//     //           </h3>

//     //           <div className="flex flex-col sm:flex-row lg:gap-6 gap-4 lg:py-4">
//     //             <div className="py-2">
//     //               <div className="mt-2 lg:ml-4 ml-2 mb-2">
//     //                 <img
//     //                   src={
//     //                     tender.company_logo
//     //                       ? `${PHOTO_BASE_URL_Admin}${tender.company_logo}`
//     //                       : 'TenderLogo'
//     //                   }
//     //                   alt={`${tender.name} Logo`}
//     //                   className="lg:w-36 w-36 h-20 lg:h-28 md:mx-auto lg:mx-auto"
//     //                 />
//     //               </div>
//     //               <div>
//     //                 <TenderDescriptionDate
//     //                   data={{
//     //                     endDate: tender.end_date,
//     //                     publishOn: tender.publish_on,
//     //                     openingDate: tender.opening_date,
//     //                   }}
//     //                 />
//     //               </div>
//     //             </div>
//     //             <div className="lg:py-4 -mt-0 md:mt-6 md:pl-44 pl-2 py-3">
//     //               <div>
//     //                 <TenderDescriptionID
//     //                   data={{
//     //                     tenderID: tender.tender_id,
//     //                     EarnestMoney: tender.earnest_money,
//     //                     DocumentPrice: tender.documents_price,
//     //                     PrebidMeetingDate: tender.prebid_meeting_date,
//     //                     PurchaseLastDate: tender.purchase_last_date,
//     //                   }}
//     //                 />
//     //               </div>
//     //             </div>
//     //           </div>

//     //           <div className="flex md:-ml-3 justify-center mt-4">
//     //             <button
//     //               // onClick={() => handleViewDetailsClick()}
//     // onClick={e => {
//     //   e.stopPropagation();
//     //   handleViewDetailsClick(tender.ten_id);
//     // }}
//     // className="bg-blue-700 text-white py-2 px-4 rounded-lg hover:bg-green-600"
//     //             >
//     //               View Details
//     //             </button>
//     //           </div>

//     //           <FaHeart
//     //             // className={`absolute top-4 right-4 cursor-pointer ${
//     //             //   wishlist.includes(tender.id) ? 'text-red-500' : 'text-black'
//     //             //   }`}
//     // className="absolute top-4 right-4 cursor-pointer text-red-500"
//     // onClick={() => removeFromFavorites(tender)}
//     //             // className={`absolute top-4 right-4 cursor-pointer ${
//     //             //   wishlist.some(item => item.id === tender.id)
//     //             //     ? 'text-red-500'
//     //             //     : 'text-black'
//     //             // }`}
//     //             // onClick={() => toggleWishlist(tender)}
//     //           />

//     //           <div className="absolute bottom-4 right-4 flex items-center text-gray-500">
//     //             <FaEye className="mr-1" />
//     //             <span>{tender.views || 0}</span>
//     //           </div>
//     //         </div>
//     //       ))
//     //     ) : (
//     //       // <p className="text-center text-red-500">No Tender found.</p>
//     //       <div className="col-span-full text-cente flex items-center justify-center md:w-3/4 w-full py-4 md:py-10">
//     //         <img src={tenderNotFoundImage} alt="" className="w-80 h-80" />
//     //       </div>
//     //     )}
//     //   </div>

//     //   <div className="flex justify-center gap-6 md:w-3/4 w-full items-center md:mt-8 mt-6">
//     //     <button
//     //       onClick={handlePrevPage}
//     //       disabled={currentPage === 1}
//     //       className="md:px-4 px-2 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded disabled:opacity-50"
//     //     >
//     //       &lt; Previous
//     //     </button>
//     //     <span>
//     //       Page {currentPage} of {totalPages}
//     //     </span>
//     //     <button
//     //       onClick={handleNextPage}
//     //       disabled={currentPage === totalPages}
//     //       className="md:px-4 px-2 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded disabled:opacity-50"
//     //     >
//     //       Next &gt;
//     //     </button>
//     //   </div>
//     // </div>
//   );
// };

// export default MyFavorite;